<template>
  <nav id="threads">
    <ul style="display:none;">
      <li :key="thread.id" v-for="thread in threads" :class="(thread.pending&&(($config.FROM.id in thread.pending)||managesPending(thread.pending))?'pending':'')">
        <a target="_blank" :href="($config.FROM.trader?'/admin/_listings/views/_full.cfm?aucID='+thread.auctionID+'&vchat_user_id='+toUserID(thread):'/listings/listing_detail.cfm?aucID='+thread.auctionID)">
          <span v-if="thread.pendingCount&&($config.FROM.id in thread.pendingCount)" class="badge">{{thread.pendingCount[$config.FROM.id]}}</span>
          <img v-if="thread.auctionImage" :src="fixAuctionImage(thread.auctionImage)" />
          <span class="label"><strong v-if="thread.TO.id==userID">{{thread.FROM.name}}</strong><strong v-else>{{thread.TO.name}}</strong><br><em>{{thread.auctionTitle}}</em></span>
        </a>
      </li>
    </ul>
    <button ref="knockingAudioTrigger" style="display:none" @click="playKnocking" />
  </nav>
</template>
<script>
import { db } from '@/firebase';

export default {
  name: 'Navigation',
  data() {
    return {
      threads:[],
      userID:null,
      threadKeys:{}
    }
  },
  methods: {
    fixAuctionImage(auctionImage){
      return auctionImage.replace('_spjpg','_sp.jpg').replace('_sppng','_sp.png');
    },
    managesPending(pending){
      if(this.$config.FROM.manages){
        let arr = this.$config.FROM.manages.filter((item)=>(item in pending));
        return (arr.length>0);
      }else{
        return false;
      }
    },
    toUserID(thread){
      return (
        (thread.TO.id==this.userID||(this.$config.FROM.manages.indexOf(thread.TO.id)>-1))?
        thread.FROM.id:
        thread.TO.id
      );
    },
    playKnocking(){
      let knock = new Audio('http://soundbible.com/mp3/Pling-KevanGC-1485374730.mp3');
      knock.play();
    },
    async chunkThreads(participants){
      let vm = this;
      let threads = await db.collection('/threads')
      .where('participants','array-contains-any',participants)
      .orderBy('updated','desc')
      .limit(100)
      .get();
      if(!threads.empty){
        threads.forEach((thread)=>{
          vm.threadKeys[thread.id]=true;
          if(thread.data().TO&&thread.data().FROM) vm.threads.push({id:thread.id,...thread.data()});
        });
      }
      db.collection('/threads').where('participants','array-contains-any',participants).orderBy('updated','desc').limit(100).onSnapshot(function(snapshot) {
        snapshot.docChanges().forEach((change)=>{
          let doc = change.doc;
          let data = doc.data();
          if (change.type === "added") {
            if(!(doc.id in vm.threadKeys)){
              vm.threads.unshift({id:doc.id,...data});
              if(data.TO.id==vm.$config.FROM.id) vm.$refs.knockingAudioTrigger.click();
            }
          }else if(change.type === "modified"){
            vm.threads = vm.threads.map((thread)=>{
              if(thread.id===doc.id){
                let existingPending = (thread.pendingCount&&(vm.$config.FROM.id in thread.pendingCount)?thread.pendingCount[vm.$config.FROM.id]:0);
                let newPending = (data.pendingCount&&(vm.$config.FROM.id in data.pendingCount)?data.pendingCount[vm.$config.FROM.id]:0);
                if(newPending>existingPending){
                  if(window.jQuery){
                    let $ = window.jQuery;
                    $( "#dialogNewChatMessage" ).dialog({
                      resizable: false,
                      height: "auto",
                      modal: true,
                      buttons: {
                        "Yes": function() {
                          let url = (vm.$config.FROM.trader?'/admin/_listings/views/_full.cfm?aucID='+thread.auctionID+'&vchat_user_id='+vm.toUserID(thread):'/listings/listing_detail.cfm?aucID='+thread.auctionID);
                          window.open(url);
                          $( this ).dialog( "close" );
                        },
                        "No": function() {
                          $( this ).dialog( "close" );
                        }
                      }
                    });
                  }
                }
              }
              return thread.id===doc.id?{id:doc.id,...data}:thread;
            });
          }
        });
      });
    }
  },
  async created(){
    let vm = this;
    vm.userID=this.$config.FROM.id;

    if(vm.$config.FROM.manages&&vm.$config.FROM.manages.length>0){
      var i,j,participants,chunk = 10;
      for (i=0,j=vm.$config.FROM.manages.length; i<j; i+=chunk) {
          participants = vm.$config.FROM.manages.slice(i,i+chunk).map(m=>parseInt(m));
          vm.chunkThreads(participants);
      }
    }

    vm.chunkThreads([this.$config.FROM.id]);

  },
  mounted(){

  }
}
</script>
